import { z } from "zod";
export const GetBackendHubAccessTokenArgs = z.object({});
export const GetBackendHubAccessTokenResponse = z.object({
    token: z.nullable(z.string()),
    message: z.string(),
});
//# sourceMappingURL=backendhub.js.map